import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

export const ElixirBackofficePreset = definePreset(Aura, {
    semantic: {
        // Compact form fields; styles.scss pins every control to --control-h (36px)
        formField: {
            paddingX: '0.75rem',
            paddingY: '0.4rem',
        },
        colorScheme: {
            light: {
                primary: {
                    50: '#EEF3FD',
                    100: '#DCE6FB',
                    200: '#B9CDF6',
                    300: '#8FB0F0',
                    400: '#5B83E2',
                    500: '#2A5EDE',
                    600: '#234FC0',
                    700: '#1E429E',
                    800: '#1E3A8A',
                    900: '#1A3070',
                    950: '#111F4A',
                },
                /*  highlight: {
                     background: '{purple.700}',
                     focusBackground: '{zinc.700}',
                     color: '#ffffff',
                     focusColor: '#ffffff',
                 },
                 custom: {
                     cardcolor: '{blue.500}',
                 }, */
            },
            dark: {
                primary: {
                    50: '#EEF3FD',
                    100: '#DCE6FB',
                    200: '#B9CDF6',
                    300: '#8FB0F0',
                    400: '#8FB0F0',
                    500: '#5B83E2',
                    600: '#2A5EDE',
                    700: '#234FC0',
                    800: '#1E429E',
                    900: '#1E3A8A',
                    950: '#111F4A',
                },
                /*   highlight: {
                      background: 'rgba(250, 250, 250, .16)',
                      focusBackground: 'rgba(250, 250, 250, .24)',
                      color: 'rgba(255,255,255,.87)',
                      focusColor: 'rgba(255,255,255,.87)',
                  },
                  custom: {
                      cardcolor: '{green.500}',
                  }, */
            },
        },
    },
    components: {
        /*  card: {
             colorScheme: {
                 light: {
                     root: {
                         background: '{indigo.400}',
                         borderRadius: '4px',
                     },
                 },
                 dark: {
                     root: {
                         background: '{custom.cardcolor}',
                         borderRadius: '4px',
                     },
                 },
             },
         }, */
    },
});

// refer " https://github.com/NataliaJeszke/angular19-lint-docker/blob/main/src/styles.ts"
// https://www.youtube.com/watch?v=68Kfv2MsFvk